import reducer from './reducer'
import * as selectors from './selectors'

export { selectors }
export const { toggleMenu } = reducer.actions
export default reducer
